import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SuccessDialogComponent } from '@shared/modules/dialogs/success-dialog/success-dialog.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [SuccessDialogComponent],
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule, FontAwesomeModule, TranslocoModule]
})
export class SuccessDialogModule {}
